/* 司馬懿傳・第 4 章：洛陽・高平陵（248–249 年）
 * 洛陽城佔北半張圖：東北是司馬懿的府第，西北是永寧宮（郭太后），北牆正中是宮城的司馬門；
 * 城中偏南是曹爽府（門前有樓），西南、東南各是爽、羲的營；南牆兩座城門：西邊平昌門、東邊津陽門。
 * 城南是洛水，浮橋在津陽門正南；再往南是伊水，曹爽奉天子宿在伊水南岸，伐樹為鹿角。 */
export const CITY = { x: 4000, y: 1900, hw: 2600, hh: 1250 };
const T = 36, N = CITY.y - CITY.hh, S = CITY.y + CITY.hh, Wx = CITY.x - CITY.hw, E = CITY.x + CITY.hw;
export const HOME = [6000, 1100], BED = [6100, 1000], PALACE = [2300, 1050], SIMAMEN = [4000, N + 200], SHUANG = [4500, 2300], TOWER = [4750, 2150];
export const SHUANG_YING = [1900, 2600], XI_YING = [6300, 2650], PINGCHANG = [2600, S], JINYANG = [4700, S], BRIDGE = [4700, 4000], CAO = [4700, 5500], YI_Y = 4850;
export default {
  id: 'simayi_luoyang', name: '洛陽', W: 8000, H: 6000, seed: 2491,
  bases: [HOME, CAO],
  walls: [[CITY.x, N, CITY.hw + T, T], [Wx, CITY.y, T, CITY.hh], [E, CITY.y, T, CITY.hh],
    [(Wx + PINGCHANG[0] - 130) / 2, S, (PINGCHANG[0] - 130 - Wx) / 2, T], [(PINGCHANG[0] + JINYANG[0]) / 2, S, (JINYANG[0] - PINGCHANG[0] - 260) / 2, T], [(E + JINYANG[0] + 130) / 2, S, (E - JINYANG[0] - 130) / 2, T]],
  rivers: [
    { pts: [[-100, 4050], [2500, 3950], BRIDGE, [8100, 4050]], hw: 150, fords: [] }, // 洛水（浮橋在路上）
    { pts: [[-100, YI_Y], [3000, YI_Y - 60], [6000, YI_Y + 40], [8100, YI_Y]], hw: 120, fords: [[2000, YI_Y - 30, 160], [7000, YI_Y + 20, 160]] }, // 伊水（兩處淺灘）
  ],
  roads: [
    { pts: [HOME, [5400, 1500], [4700, 1700], SHUANG, [4700, 2700], JINYANG, BRIDGE, [4700, YI_Y - 300]], w: 150 },
    { pts: [[4700, 1700], [4000, 1500], SIMAMEN], w: 130 },
    { pts: [[4000, 1500], [3000, 1300], PALACE], w: 120 },
    { pts: [[3000, 1300], [2700, 2300], SHUANG_YING], w: 110 },
    { pts: [[2700, 2300], PINGCHANG, [2400, 3700], [2000, 4600], [1200, 5600]], w: 110 }, // 桓範出平昌門，往南奔爽
    { pts: [[5400, 1500], [6200, 2200], XI_YING], w: 110 },
    { pts: [[4700, YI_Y + 300], CAO], w: 130 },
  ],
  rocks: [[7300, 5500, 400, 200], [600, 3600, 300, 160]],
  woods: 0.25,
  sight: 1,
  clearings: [[HOME[0], HOME[1], 500], [PALACE[0], PALACE[1], 500], [SIMAMEN[0], SIMAMEN[1], 350], [SHUANG[0], SHUANG[1], 400], [SHUANG_YING[0], SHUANG_YING[1], 450], [XI_YING[0], XI_YING[1], 450], [BRIDGE[0], BRIDGE[1] - 300, 400], [CAO[0], CAO[1], 600]],
  villages: [{ x: 3300, y: 2200, n: 9, r: 500 }, { x: 5600, y: 2400, n: 6, r: 380 }, { x: HOME[0] + 400, y: HOME[1] + 200, n: 3, r: 220 }, { x: PALACE[0], y: PALACE[1] - 100, n: 3, r: 240 }],
  tents: [{ x: SHUANG_YING[0], y: SHUANG_YING[1], n: 5, r: 320, col: '#3b5a99', flag: '爽' }, { x: XI_YING[0], y: XI_YING[1], n: 5, r: 320, col: '#3b5a99', flag: '羲' }, { x: CAO[0], y: CAO[1], n: 7, r: 420, chief: true, col: '#8a6a2a', flag: '魏' }],
  fields: [[1500, 4400, 520, 220], [6500, 4400, 560, 220, '#86803f']],
};
